<template>
  <div class="ten-image__wrapper">
    <!-- @slot 自定义加载中的占位内容 -->
    <slot
      v-if="loading"
      name="placeholder"
    >
      <div class="ten-image__placeholder">
        加载中...
      </div>
    </slot>
    <!-- @slot 自定义图片加载失败后的占位内容 -->
    <slot
      v-else-if="error"
      name="error"
    >
      <div class="ten-image__error">
        加载失败
      </div>
    </slot>
    <img
      v-else
      class="ten-image"
      :class="{'ten-image--center': _alignCenter}"
      v-bind="$attrs"
      v-on="$listeners"
      :src="src"
      :style="_imageStyle"
    >
  </div>
</template>

<script>

const name = 'ten-image';

const isSupportObjectFit = () => document.documentElement.style.objectFit !== undefined;
const ObjectFit = {
  NONE: 'none',
  CONTAIN: 'contain',
  COVER: 'cover',
  FILL: 'fill',
  SCALE_DOWN: 'scale-down',
};

export default {
  name,
  props: {
    /**
     * 图片链接
     */
    src: {
      type: String,
      default: '',
    },
    /**
     * 图片 object-fit
     * @member 'none'|'contain'|'cover'|'fill'|'scale-down'
     */
    fit: {
      type: String,
      default: 'none',
    },
  },

  data() {
    return {
      loading: true,
      error: false,
      imgWidth: 0,
      imgHeight: 0,
    };
  },

  computed: {
    _imageStyle() {
      return isSupportObjectFit() ? {
        'object-fit': this.fit,
      } : this.getImageStyle();
    },
    _alignCenter() {
      return !isSupportObjectFit() && this.fit !== ObjectFit.FILL;
    },
  },

  watch: {
    src(val, oldVal) {
      if (val !== oldVal) {
        this.loadingImg();
      }
    },
  },

  mounted() {
    this.loadingImg();
  },

  methods: {
    loadingImg() {
      this.loading = true;
      this.error = false;

      const img = new Image();
      img.onload = e => this.imgLoadHandler(e, img);
      img.onerror = e => this.imgErrorHandler(e, img);

      Object.keys(this.$attrs).forEach((key) => {
        const value = this.$attrs[key];
        img.setAttribute(key, value);
      });

      img.src = this.src;
    },

    imgLoadHandler(e, img) {
      this.imgWidth = img.width;
      this.imgHeight = img.height;
      this.loading = false;
    },

    imgErrorHandler(e) {
      this.loading = false;
      this.error = true;
      /**
       * 图片加载失败回调
       */
      this.$emit('error', e);
    },

    getImageStyle() {
      const { imgWidth, imgHeight } = this;
      let { fit } = this;
      const {
        clientWidth: containerWidth,
        clientHeight: containerHeight,
      } = this.$el;
      if (!imgWidth || !imgHeight || !containerWidth || !containerHeight) return {};
      const vertical = imgWidth / imgHeight < 1;
      if (fit === ObjectFit.SCALE_DOWN) {
        const isSmaller = imgWidth < containerWidth && imgHeight < containerHeight;
        fit = isSmaller ? ObjectFit.NONE : ObjectFit.CONTAIN;
      }
      switch (fit) {
        case ObjectFit.NONE:
          return { width: 'auto', height: 'auto' };
        case ObjectFit.CONTAIN:
          return vertical ? { width: 'auto' } : { height: 'auto' };
        case ObjectFit.COVER:
          return vertical ? { height: 'auto' } : { width: 'auto' };
        default:
          return {};
      }
    },

    // TODO: lazy?
  },
};
</script>
